import { Injectable } from '@angular/core';
import { Provider } from '../provider';
import { IEventCategory } from 'src/app/models/event-category.model';

@Injectable()
export class EventCategoryService extends Provider<IEventCategory> {
  protected url = "events/categories";
}
